import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: /*#__PURE__*/_normalizeClass(``)
}
const _hoisted_2 = {
  key: 0,
  class: /*#__PURE__*/_normalizeClass(`fl w40 pad20`)
}
const _hoisted_3 = { class: "w100 rad20 pad20 llgreyBg" }
const _hoisted_4 = { class: "fl mt20 fs16 fw600" }
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", {
  class: "fs11",
  style: {"margin-top":"-5px"}
}, [
  /*#__PURE__*/_createTextVNode("フォーム内容"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("を閉じる")
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_11 = { class: "w100" }
const _hoisted_12 = { class: "fl mr6 mb5" }
const _hoisted_13 = { class: "fl" }
const _hoisted_14 = { class: "fs14 mt4" }
const _hoisted_15 = { class: "fl mb0 fw600" }
const _hoisted_16 = {
  key: 0,
  class: "fl fs11 fw600"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_18 = { class: "fs11" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_21 = { class: "fl mt30 fs16 fw600" }
const _hoisted_22 = ["src"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "centered fs18 fw600 mt20" }, "アドレス帳から出席者を選択", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "text-left" }, "アドレス帳から選択した送信先に複数まとめて送信ができます。", -1)
const _hoisted_27 = {
  key: 0,
  class: ""
}
const _hoisted_28 = { class: "w100 pad20" }
const _hoisted_29 = { style: {"min-height":"45px"} }
const _hoisted_30 = { class: "fl mr20 mt14 fw600" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = {
  key: 0,
  class: "w100"
}
const _hoisted_33 = {
  key: 0,
  class: "posAb z1",
  style: {"width":"18px","top":"0","left":"0"}
}
const _hoisted_34 = ["src"]
const _hoisted_35 = ["src"]
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_37 = { key: 1 }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("p", { class: "grey fl mt14" }, "出席者がいません。アドレス帳から追加してください。", -1)
const _hoisted_39 = ["src"]
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_41 = {
  key: 0,
  style: {"min-height":"45px"}
}
const _hoisted_42 = /*#__PURE__*/_createElementVNode("p", { class: "fl mr20 mt14 fw600" }, "任意出席者", -1)
const _hoisted_43 = { class: "w100" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_46 = {
  key: 0,
  class: "pad20 llgreyBg rad20",
  style: {"min-height":"45px"}
}
const _hoisted_47 = { class: "fl mr20 mt14 fw600" }
const _hoisted_48 = {
  key: 0,
  class: "w100"
}
const _hoisted_49 = {
  class: "posAb z1",
  style: {"width":"18px","top":"-10px","right":"-15px"}
}
const _hoisted_50 = ["src", "onClick"]
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_52 = { key: 1 }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("p", { class: "grey fl mt14" }, [
  /*#__PURE__*/_createTextVNode(" 日程決定者がいません。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 設定すると、出席可能かの○×の確認と日程の確定をすることができるようになります。（投票後に設定も可能です） ")
], -1)
const _hoisted_54 = ["src"]
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_56 = {
  key: 1,
  class: "mt20"
}
const _hoisted_57 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_58 = { key: 2 }
const _hoisted_59 = {
  class: "pad20 llgreyBg rad20",
  style: {"min-height":"45px"}
}
const _hoisted_60 = { class: "fl mr20 mt14 fw600" }
const _hoisted_61 = {
  key: 0,
  class: "w100"
}
const _hoisted_62 = {
  class: "posAb z1",
  style: {"width":"18px","top":"0","left":"0"}
}
const _hoisted_63 = ["src"]
const _hoisted_64 = ["src"]
const _hoisted_65 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_66 = { key: 1 }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("p", { class: "grey fl mt14" }, [
  /*#__PURE__*/_createTextVNode("投票したメンバーは全員が出席者に選択されています。"),
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_68 = ["src"]
const _hoisted_69 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserIcon = _resolveComponent("UserIcon")!
  const _component_AnsweredFormTable = _resolveComponent("AnsweredFormTable")!
  const _component_AddressBookContent = _resolveComponent("AddressBookContent")!
  const _component_UserIconSendMenu = _resolveComponent("UserIconSendMenu")!
  const _component_IconHelp = _resolveComponent("IconHelp")!
  const _component_SendMailContent = _resolveComponent("SendMailContent")!

  return (_openBlock(), _createElementBlock("div", {
    class: "w100",
    style: _normalizeStyle({
            height: _ctx.height || `100vh`,
        })
  }, [
    _createElementVNode("section", _hoisted_1, [
      (_ctx.currentAnsweredFormMem)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("img", {
                  src: _ctx.$getAssetImageUrl(`/assets/icons/user_black.png`),
                  width: "24",
                  height: "26",
                  style: {"margin-top":"-3px"}
                }, null, 8, _hoisted_5),
                _createTextVNode(" 基本情報 "),
                _hoisted_6
              ]),
              _createElementVNode("div", {
                class: "fr centered pointer",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeForm && _ctx.closeForm(...args)))
              }, [
                _createElementVNode("img", {
                  src: _ctx.$getAssetImageUrl(`/assets/popUp/close_dark_grey.png`),
                  width: "40",
                  height: "40",
                  class: ""
                }, null, 8, _hoisted_7),
                _hoisted_8,
                _hoisted_9
              ]),
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_UserIcon, {
                    member: _ctx.currentAnsweredFormMem,
                    width: 38,
                    canEdit: false,
                    updateSelf: false,
                    showTooltip: false
                  }, null, 8, ["member"])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.currentAnsweredFormMem.name), 1),
                    (_ctx.Util.isPresent(_ctx.currentAnsweredFormMem.company_name))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_16, " (" + _toDisplayString(_ctx.currentAnsweredFormMem.company_name) + ") ", 1))
                      : _createCommentVNode("", true),
                    _hoisted_17
                  ]),
                  _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.currentAnsweredFormMem.email), 1)
                ]),
                _hoisted_19
              ]),
              _hoisted_20,
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("img", {
                  src: _ctx.$getAssetImageUrl(`/assets/icons/form_icon.png`),
                  width: "20",
                  height: "20",
                  style: {"margin-top":"-3px"}
                }, null, 8, _hoisted_22),
                _createTextVNode(" フォーム内容 ")
              ]),
              _hoisted_23,
              _createVNode(_component_AnsweredFormTable, {
                results: _ctx.currentAnsweredFormMem.answer_results,
                room: _ctx.currentAnsweredParentRoom,
                canEdit: false,
                class: "mt20"
              }, null, 8, ["results", "room"]),
              _hoisted_24
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "fl w40 with_white_bg rad20 pad10 ofs",
            style: _normalizeStyle({
                    height: _ctx.height || `100vh`,
                })
          }, [
            _hoisted_25,
            _hoisted_26,
            (_ctx.rm.userInfo)
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  _createVNode(_component_AddressBookContent, {
                    style: `margin-top:20px;padding:20px;`,
                    class: _normalizeClass(``),
                    members: [],
                    currentMember: _ctx.currentMember,
                    editOrNewForm: _ctx.editOrNewForm,
                    showEditButton: false,
                    showNewButton: true,
                    onAddAttendee: _ctx.addAttendee,
                    onSelectContactListGroup: _ctx.selectContactListGroup
                  }, null, 8, ["currentMember", "editOrNewForm", "onAddAttendee", "onSelectContactListGroup"])
                ]))
              : _createCommentVNode("", true)
          ], 4)),
      _createElementVNode("div", {
        class: "fl w60 pad20 with_white_bg ofs",
        style: _normalizeStyle({
                    height: _ctx.height || `100vh`,
                })
      }, [
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("p", _hoisted_30, [
              (_ctx.viewType == `mail`)
                ? (_openBlock(), _createElementBlock("span", _hoisted_31, "必須"))
                : _createCommentVNode("", true),
              _createTextVNode("出席者")
            ]),
            (_ctx.Util.isPresent(_ctx.members))
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.members, (mem, memindex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "fl mr10 posRe mb20",
                      key: memindex
                    }, [
                      mem
                        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                            (mem.attendable)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: _ctx.$getAssetImageUrl(`/assets/icons/attendee_ok.png`),
                                  width: "12",
                                  height: "12",
                                  class: "fl"
                                }, null, 8, _hoisted_34))
                              : (_openBlock(), _createElementBlock("img", {
                                  key: 1,
                                  src: _ctx.$getAssetImageUrl(`/assets/icons/attendee_ng.png`),
                                  width: "12",
                                  height: "12",
                                  class: "fl"
                                }, null, 8, _hoisted_35))
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_UserIconSendMenu, {
                        mem: mem,
                        memType: `require`,
                        viewType: _ctx.viewType,
                        onDeleteSendUser: _ctx.deleteSendUser,
                        onChangeList: _ctx.changeList,
                        onAddFixMember: _ctx.addFixMember,
                        onShowAnswerResults: _ctx.showAnswerResults,
                        onOnlyAttend: _ctx.onlyAttend
                      }, null, 8, ["mem", "viewType", "onDeleteSendUser", "onChangeList", "onAddFixMember", "onShowAnswerResults", "onOnlyAttend"])
                    ]))
                  }), 128)),
                  _hoisted_36
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_37, [
                  _hoisted_38,
                  _createElementVNode("img", {
                    src: _ctx.$getAssetImageUrl(`/assets/icons/no_rooms.png`),
                    width: "30",
                    height: "30",
                    class: "mt5 ml15"
                  }, null, 8, _hoisted_39),
                  _hoisted_40
                ]))
          ]),
          (_ctx.viewType == `mail`)
            ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                _hoisted_42,
                _createElementVNode("div", _hoisted_43, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.opMembers, (mem, memindex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "fl mr10 posRe mb20",
                      key: memindex
                    }, [
                      _createVNode(_component_UserIconSendMenu, {
                        mem: mem,
                        memType: `option`,
                        viewType: _ctx.viewType,
                        onDeleteSendUser: _ctx.deleteSendUser,
                        onChangeList: _ctx.changeList,
                        onAddFixMember: _ctx.addFixMember,
                        onOnlyAttend: _ctx.onlyAttend
                      }, null, 8, ["mem", "viewType", "onDeleteSendUser", "onChangeList", "onAddFixMember", "onOnlyAttend"])
                    ]))
                  }), 128)),
                  _hoisted_44
                ])
              ]))
            : _createCommentVNode("", true),
          _hoisted_45
        ]),
        (_ctx.viewType == `mail`)
          ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
              _createElementVNode("p", _hoisted_47, [
                _createTextVNode(" 日程決定者 "),
                _createVNode(_component_IconHelp, {
                  width: 18,
                  tooltipText: `出席可能かの○×の確認と日程の確定をすることができるようになります。（投票後に設定も可能です）`,
                  style: {"margin-top":"-3px","margin-right":"5px"}
                })
              ]),
              (_ctx.Util.isPresent(_ctx.fixMembers))
                ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fixMembers, (mem, memindex) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "fl mr20 posRe",
                        key: memindex
                      }, [
                        _createElementVNode("div", _hoisted_49, [
                          (mem.email != _ctx.rm.userInfo.email)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: _ctx.$getAssetImageUrl(`/assets/icons/dismiss_grey_dgrey.png`),
                                width: "22",
                                height: "22",
                                class: "fr pointer",
                                onClick: ($event: any) => (_ctx.deleteSendUser(mem, `fix`))
                              }, null, 8, _hoisted_50))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode(_component_UserIcon, {
                          member: mem,
                          width: 45,
                          canEdit: false,
                          updateSelf: false,
                          showTooltip: true,
                          class: "pointer"
                        }, null, 8, ["member"])
                      ]))
                    }), 128)),
                    _hoisted_51
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_52, [
                    _hoisted_53,
                    _createElementVNode("img", {
                      src: _ctx.$getAssetImageUrl(`/assets/icons/no_rooms.png`),
                      width: "30",
                      height: "30",
                      class: "mt5 ml15"
                    }, null, 8, _hoisted_54),
                    _hoisted_55
                  ]))
            ]))
          : _createCommentVNode("", true),
        (_ctx.viewType == `mail` && _ctx.currentMail)
          ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
              _createVNode(_component_SendMailContent, {
                mf: _ctx.currentMail,
                onUpdateMail: _ctx.updateMail
              }, null, 8, ["mf", "onUpdateMail"]),
              _hoisted_57
            ]))
          : (_ctx.viewType == `attendees`)
            ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                _createElementVNode("div", _hoisted_59, [
                  _createElementVNode("p", _hoisted_60, [
                    _createTextVNode(" この日程で確定しない日程投票者 "),
                    _createVNode(_component_IconHelp, {
                      width: 18,
                      tooltipText: `確定しない人の欄です。この日程では確定せず、別日程で確定できます。`,
                      style: {"margin-top":"-3px","margin-right":"5px"}
                    })
                  ]),
                  (_ctx.Util.isPresent(_ctx.vrm.notAttendees))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vrm.notAttendees, (mem, memindex) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "fl mr20 posRe",
                            key: memindex
                          }, [
                            _createElementVNode("div", _hoisted_62, [
                              (mem.attendable)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: _ctx.$getAssetImageUrl(`/assets/icons/attendee_ok.png`),
                                    width: "12",
                                    height: "12",
                                    class: "fl"
                                  }, null, 8, _hoisted_63))
                                : (_openBlock(), _createElementBlock("img", {
                                    key: 1,
                                    src: _ctx.$getAssetImageUrl(`/assets/icons/attendee_ng.png`),
                                    width: "12",
                                    height: "12",
                                    class: "fl"
                                  }, null, 8, _hoisted_64))
                            ]),
                            _createVNode(_component_UserIconSendMenu, {
                              mem: mem,
                              memType: `notAttendee`,
                              viewType: _ctx.viewType,
                              onDeleteSendUser: _ctx.deleteSendUser,
                              onChangeList: _ctx.changeList,
                              onAddFixMember: _ctx.addFixMember,
                              onShowAnswerResults: _ctx.showAnswerResults,
                              onOnlyAttend: _ctx.onlyAttend
                            }, null, 8, ["mem", "viewType", "onDeleteSendUser", "onChangeList", "onAddFixMember", "onShowAnswerResults", "onOnlyAttend"])
                          ]))
                        }), 128)),
                        _hoisted_65
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_66, [
                        _hoisted_67,
                        _createElementVNode("img", {
                          src: _ctx.$getAssetImageUrl(`/assets/icons/no_rooms.png`),
                          width: "30",
                          height: "30",
                          class: "mt5 ml15"
                        }, null, 8, _hoisted_68),
                        _hoisted_69
                      ]))
                ])
              ]))
            : _createCommentVNode("", true)
      ], 4)
    ])
  ], 4))
}